<header 
    class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a class="btn btn-link me-3 p-0 d-block d-xl-none back-canvas" data-bs-toggle="offcanvas" href="#offcanvasExample"
         role="button" aria-controls="offcanvasExample">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </a>

        
      <h3 class="heading-span" >
          <span>My Personalised Insights</span>
        </h3>
    
    </div>
  </header>

<div class="theme-card-text my-insights">
    <div class="row">
      <div class="col-md-4">
      <div class="startup-toolkit " style="height: 650px;">
        <h4 class="theme-card-text">Startup Toolkit</h4>
        <mat-divider style="margin-bottom: 1em;"></mat-divider>
        <em>Click <span><mat-icon style="vertical-align: middle;">app_registration</mat-icon>My Insights</span> or 
          a <span><mat-icon style="vertical-align: middle;">insert_chart</mat-icon>toolkit</span> icon to change the startup toolkit. 
          If you want to change/toggle the default view also, it can be done from the report menu 
          <span><mat-icon style="vertical-align: middle;">menu_outlined</mat-icon></span> with the desired view open.
          If there is no startup toolkit, the first toolkit will be opened by default.
        </em>
        <mat-divider style="margin-bottom: 1em;"></mat-divider>
        <ul class="startup-toolkit-list" style="height: 420px;overflow-y: auto;" >
          <li 
          [class.selected-toolkit]="this.thisToolkit==null"
          (click)="selectToolkit(null,null,null)"
          class="startup-toolkit-item" [class.startup-on]="startupSubcategory==0"><mat-icon (click)="toggleStartup(0)"  style="vertical-align: middle;">app_registration</mat-icon>
          <span class="toolkit-name">My Insights</span></li>
        @for (module of this.packageInformation.modules; track module) {
          <li>
            <div title="{{module.moduleName}}"><mat-icon style="vertical-align: middle;">folder_open</mat-icon>{{module.moduleName}}</div>
            <ul>
            @for(toolkitGroup of module.subCategoryGrouping; track toolkitGroup){
              @if(toolkitGroup.groupName==null ||toolkitGroup.items.length<=1){
                
                  @for(toolkit of toolkitGroup.items; track toolkit){
                    <li class="startup-toolkit-item"  
                      title="{{toolkit.subCategoryName}}"
                      [class.selected-toolkit]="this.thisToolkit?.packageSubCategoryId==toolkit.packageSubCategoryId"
                      (click)="selectToolkit(module, null, toolkit);"
                      [class.startup-on]="startupSubcategory==toolkit.packageSubCategoryId">
                      <mat-icon 
                        (mouseenter)="iconHover=toolkit.packageSubCategoryId" 
                        (mouseleave)="iconHover=null"    
                        (click)="toggleStartup(toolkit.packageSubCategoryId)"  
                        [class.switch-off]="(iconHover==toolkit.packageSubCategoryId) && (startupSubcategory==toolkit.packageSubCategoryId)"
                        style="vertical-align: middle;">
                        {{(iconHover==toolkit.packageSubCategoryId) ||(startupSubcategory==toolkit.packageSubCategoryId)?'power_settings_new':'insert_chart'}}</mat-icon>
                      <span class="toolkit-name">{{(toolkit?.subCategoryDisplayName)??toolkit.subCategoryName}}</span>
                    </li>
                  }
              }
              @else{
                <li>
                  <div><mat-icon style="vertical-align: middle;">short_text</mat-icon>{{  toolkitGroup.groupName}}</div>
                  <ul>
                  @for(toolkit of toolkitGroup.items; track toolkit){
                    <li class="startup-toolkit-item" 
                      title="{{toolkit.subCategoryName}}"
                      [class.selected-toolkit]="this.thisToolkit?.packageSubCategoryId==toolkit.packageSubCategoryId"
                      (click)="selectToolkit(module, toolkitGroup.groupName, toolkit);"
                      [class.startup-on]="startupSubcategory==toolkit.packageSubCategoryId"
                      >
                      <mat-icon 
                        (mouseenter)="iconHover=toolkit.packageSubCategoryId" 
                        (mouseleave)="iconHover=null"  
                        [class.switch-off]="(iconHover==toolkit.packageSubCategoryId) && (startupSubcategory==toolkit.packageSubCategoryId)"
                        (click)="toggleStartup(toolkit.packageSubCategoryId)"  
                        style="vertical-align: middle;">
                        {{(iconHover==toolkit.packageSubCategoryId) || (startupSubcategory==toolkit.packageSubCategoryId)?'power_settings_new':'insert_chart'}}</mat-icon>
                      <span class="toolkit-name">{{toolkit.subCategoryName}}</span></li>
                  }
                  </ul>
                  </li>
              }
            }
          </ul>
        </li>
        }
      </ul>
      </div>
      </div>
      <div class="col-md-8">
        <div class="startup-toolkit-views" style="height: 650px;">
          
        <h4 class="theme-card-text">Toolkit Views</h4>
        <mat-divider style="margin-bottom: 1em;"></mat-divider>
        <em>You will be able to manage the various views that have been created for the selected Toolkit. 
          You can mark one of these view as the initial view. There are three kinds of views, all of which can be created from the toolkit <span><mat-icon style="vertical-align: middle;">menu_outlined</mat-icon></span> menu: 
          (1) Default - This is the system default view.
          (2) Bookmark - This is a saved view for this toolkit.
          (3) Filters - This is a saved list of filters from this toolkit, but can be applied to other toolkits with the same set of Slicers.
        </em>
        <mat-divider style="margin-bottom: 1em;"></mat-divider>
        <div class="row">

          <div class="col-md-12" >
            <em *ngIf="thisToolkit==null">Select a toolkit</em>
            <h3 *ngIf="thisToolkit!=null" style="font-size: 1em;">
              <mat-icon style="vertical-align: middle;">folder_open</mat-icon>{{thisModule?.moduleName}} 
              @if(thisToolkitGroupName!=null){
                 &nbsp;
                <mat-icon style="vertical-align: middle;">chevron_right</mat-icon>
                &nbsp;
                <mat-icon style="vertical-align: middle;">short_text</mat-icon>
                {{thisToolkitGroupName}}
              }
              &nbsp;
              <mat-icon style="vertical-align: middle;">chevron_right</mat-icon>
              &nbsp;
              <mat-icon style="vertical-align: middle;">insert_chart</mat-icon>
              @if(thisToolkitGroupName==null){
                {{thisToolkit.subCategoryDisplayName??this.thisToolkit.subCategoryName}}  
              }
              @else{
                {{this.thisToolkit.subCategoryName}}
              }
              <span class="badge badge-secondary">{{this.thisToolkit.userReportViews?.length}}</span>
            
            <div style="float: right;border-left: 1px solid silver;height: 100%;padding-left:1em;;">
              <mat-slide-toggle *ngIf="selectReportView!=null && selectReportView.snapShotType=='Filters'"
              [disabled]="!selectReportView!.isShared" title="Coming Soon: Sharing a filter will allow it to be used across reports."
              (change)="SaveShared(selectReportView!)"
              [(ngModel)]="selectReportView!.isShared">Shared</mat-slide-toggle>
              &nbsp;
              <mat-slide-toggle *ngIf="selectReportView!=null"
              (change)="SaveFavourite(selectReportView!)"
              [(ngModel)]="selectReportView!.isFavourite">Favourite</mat-slide-toggle>
            </div>
            </h3>
          </div>
        </div>
        <mat-divider style="margin-bottom: 1em;"></mat-divider>
        <div class="row"  *ngIf="thisToolkit!=null">
          <div class="col-md-4">
            <mat-list style="height: 375px;overflow-y: auto;" class="toolkit-view-list">
              <mat-list-item (click)="selectView(null)"
                class="toolkit-view-list-item"
                [class.selected-toolkit-view]="thisToolkit.userReportViewId==0"
                [class.startup-on]="thisToolkit.defaultUserReportViewId==0"
              >
                <mat-icon (click)="toogleInitialView(null)" *ngIf="thisToolkit.defaultUserReportViewId==0">bookmark</mat-icon>
                <mat-icon (click)="toogleInitialView(null)" *ngIf="thisToolkit.defaultUserReportViewId!=0">bookmark_border</mat-icon>
                <span class="toolkit-view-name">Default</span>
              </mat-list-item>

              <mat-list-item *ngFor="let rv of this.thisToolkit.userReportViews" 
              (click)="selectView(rv)"
              class="toolkit-view-list-item"
              [class.selected-toolkit-view]="this.selectReportView?.userReportViewId==rv.userReportViewId"
              [class.startup-on]="rv.isStartup"
              [class.shared-on]="rv.isShared">
                    <mat-icon class='toolkit-view-icon' (click)="toogleInitialView(rv)"  *ngIf="rv.isStartup">
                      {{rv.snapShotType=='Snapshot'?'bookmark':'filter_list'}}
                    </mat-icon>
                    <mat-icon class='toolkit-view-icon' (click)="toogleInitialView(rv)" *ngIf="!rv.isStartup">
                      {{rv.snapShotType=='Snapshot'?'bookmark_border':'filter_list'}}
                    </mat-icon>
                    <span class="toolkit-view-name" 
                    (dblclick)="startEditName(rv)" title="double click to edit">
                      <input 
                        (keydown.esc)="cancelEdit(rv)"
                        (blur)="commitEdit(rv)"
                        (keydown.enter)="commitEdit(rv)"
                        *ngIf="editReportView!=null && editReportView.userReportViewId==rv.userReportViewId && editReportView.userReportViewId==selectReportView?.userReportViewId" 
                        type="text" matInput  [(ngModel)]="editReportView.viewName">
                      <span *ngIf="editReportView==null || editReportView.userReportViewId!=rv.userReportViewId">{{rv.viewName}}</span></span>
                    <mat-icon (click)="deleteReportView(rv)" class="toolkit-view-name-delete">delete</mat-icon>
              </mat-list-item>
            </mat-list>

          </div>
          <div class="col-md-8">
            
            <div style="height: 375px;overflow-y: auto;">
              @if(this.selectReportView==null){
                @if(this.startupSubcategory!=this.thisToolkit.packageSubCategoryId){
                  <em>Initial page can only be set for the startup Toolkit.</em>
                }
                @else if(this.startupSubcategoryPageName==null)
                {
                  <em>This is the system designed view, and has no customisations.</em>
                }
                @else{
                  <em>A custom initial view has associated.</em>
                }
              }
              @else if(reportViewBookmark!=null){
                
                <em>Bookmark settings are encrypted and cannot be displayed</em>
                
              }
              @else if(reportSlicerStates!=null){
                @for ( slicer of reportSlicerDescriptions; track slicer) {
                  
                      <div class="user-report-filter-item">
                          <mat-icon (click)="deleteSlicerFilter(slicer)" class="user-report-filter-delete">delete</mat-icon>
                        @for(target of slicer.filters; track target){
                          <div >
                          [{{target.table}}].[{{target.column}}]
                          <p>
                          <em>{{target.values}}
                          </em>
                          </p>
                        </div>
                        }
                     
                    </div>
                }
              }
            </div>
          </div>
        </div>
        
        </div>
      </div>
    </div>
</div>